<template lang="pug">
#app
  .loading.prefetch
  legacy-auth
  md-notifications
  router-view
  .close-layer(v-if='!session && store.state.isLoggedIn')
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import {store}                   from '@/components/store'
import {i18n, loadLanguageAsync} from '@/lang/lang'

const $t = (key) => i18n.t(key)

export default {
  name: 'app',

  boot(config) {
    global.app = new config.Vue({
      el         : '#app',
      store      : config.store,
      i18n       : config.i18n,
      router     : config.router,
      template   : '<App/>',
      components : { App: config.App },
      data       : {
        loading  : false,
        Chartist : config.Charts.Chartist
      },
      asyncComputed : {
        getUser     : config.API.getUser
      }
    })

    utils.app = global.app
  },

  created() {
    // i18n
    const lang = navigator.language
    // const lang = 'ro'
    loadLanguageAsync(lang)

    // this.pubnub.load()

    //
    this.$notifications.reset()
  },

  mounted() {
    //
    utils.cssProps.init()
  },

  updated() {
    //
    utils.cssProps.refresh()
  },

  data() {
    return {
      store
    }
  },

  computed: {
    /**
     * Check session mapped in store and display a notification
     * if logged in and session is invalid
     */
    session() {
      var sessionNotifyIndex

      if (global.app.$notifications && this.$router.currentRoute.params.namespace !== 'docs') {
        setTimeout(() => {
          if (store.state.isLoggedIn && !store.state.isSessionValid) {
            sessionNotifyIndex = global.app.$notifications.state.length + 1
            global.app.$notifications.notify({
              type: 'plain',
              icon: 'exclamation-circle',
              message: $t('Session Expired') +
                        `<br><a href="#/login" onclick='window.app.$user.logout()'>` + $t('login.button') + `</a>`,
              timeout: 0,
              allowDismiss: false,
              placement: { from: 'top', align: 'center' }
            })
          } else {
            global.app.$notifications.removeNotification(sessionNotifyIndex)
          }
        })
      }

      return store.state.isSessionValid
    }
  }
}

</script>

<style lang='scss'>
@import '~@/assets/sass/font-awesome/fontawesome-pro-brands.scss';
@import '~@/assets/sass/font-awesome/fontawesome-pro-core.scss';
@import '~@/assets/sass/font-awesome/fontawesome-pro-light.scss';
@import '~@/assets/sass/font-awesome/fontawesome-pro-regular.scss';
@import '~@/assets/sass/font-awesome/fontawesome-pro-solid.scss';

@import "~@/assets/sass/_variables.scss";

#layout {
  height: 100%;

  .main-panel {
    overflow-y: scroll;
  }
  &.layout-auth .main-panel {
    overflow-y: auto;
  }

  .grid.component {
    padding-top: 0;
  }
}

#layout {
  .card:not(.r-show) {
    display: inherit;
  }
  &.scoped .card:not(.r-show) {
    display: none;
  }
  &.scoped [class^="col-"] {
    min-height: 0;
  }
}

.close-layer {
  background: #555;
  height: 100%;
  width: 100%;
  position: absolute;
  opacity: 0.8;
  top: 0;
  left: auto;
  content: "";
  z-index: 9999;
  overflow-x: hidden;
  &.visible{
      opacity: 1;
  }
  .theme.docs + & {
    display: none;
  }
}

.notifications {
  position: relative;
  z-index: 10000;
}

.loading {
  position: relative;
  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
    font: 50px 'Font Awesome 5 Regular';
    content: '\f1ce';
    //content: '';
    z-index: 10000;
    animation: fa-spin 2s infinite linear;
    color: #aaa;
    color: t(primary-04);
    //background: #eee url('../static/images/loading.svg') 50% 50% no-repeat;
    //background-size: 50px;
    //width: 50px;
    //height: 50px;
  }
  &:after {
    content: '';
    text-align: center;
    position: absolute;
    top: 0;
    left : 0;
    width: 100%;
    height: 100%;
    display: block;
    background: #eee url('../static/images/loading.svg') 50% 50% no-repeat;
    background-size: 50px;
    opacity: .55;
    z-index: 9999;
  }
  &[endpoint]:after {
    z-index: 9;
    background-image: none;
  }
  &.btn {
    color: transparent;
    cursor: not-allowed;
    box-shadow: none;
    &:hover,
    &:active,
    &:focus
    {
      color: transparent;
      box-shadow: none;
    }
    &:after {
      //background: #fff url('./assets/images/loading.gif') 50% 40% no-repeat;
      //background-size: contain;
    }
    &:before {
      font-size: 22px;
      margin-top: -11px;
      margin-left: -11px;
    }
  }
}

.prefetch {
  margin-left: -99999px;
  position: absolute;
}

</style>



// WEBPACK FOOTER //
// App.vue?e5ae2f94